import { ILogger } from "./ILogger";
import { IConfiguration } from "../../domain/configuration";
import log4javascript from "log4javascript";

export class Logger implements ILogger {
  static initialize(configuration: IConfiguration): any {
    const logger = log4javascript.getLogger();
    logger.removeAllAppenders();
    logger.setLevel(this.toLevel(configuration.debug.logger.level));
    if (configuration.debug.logger.consoleAppender.isEnable) {
      logger.addAppender(this.createConsoleAppender(configuration.debug.logger.consoleAppender));
    }
    if (configuration.debug.logger.ajaxAppender.isEnable) {
      logger.addAppender(this.createAjaxAppender(configuration.debug.logger.ajaxAppender));
    }
  }

  private static createConsoleAppender(source: { isEnable: boolean, threshold: string }): log4javascript.Appender {
    const instance = new log4javascript.BrowserConsoleAppender();
    instance.setThreshold(this.toLevel(source.threshold));
    instance.setLayout(new log4javascript.PatternLayout("%d{HH:mm:ss.SSS}:[%p] %m"));
    return instance;
  }

  private static createAjaxAppender(source: { isEnable: boolean, url: string, threshold: string }): log4javascript.Appender {
    const instance = new log4javascript.AjaxAppender(source.url);
    instance.setThreshold(this.toLevel(source.threshold));
    instance.setLayout(new log4javascript.JsonLayout());
    instance.addHeader("Content-Type", "application/json");
    instance.setBatchSize(10);
    // instance.setTimed(true);
    // instance.setTimerInterval(1000);
    // ブラウザを閉じる動作をされると出力されない模様
    instance.setSendAllOnUnload(true);
    return instance;
  }

  private static toLevel(source: string): log4javascript.Level {
    switch (source.toUpperCase()) {
      case "ALL": return log4javascript.Level.ALL; 
      case "TRACE": return log4javascript.Level.TRACE; 
      case "DEBUG": return log4javascript.Level.DEBUG; 
      case "INFO": return log4javascript.Level.INFO; 
      case "WARN": return log4javascript.Level.WARN; 
      case "ERROR": return log4javascript.Level.ERROR; 
      case "FATAL": return log4javascript.Level.FATAL; 
      case "OFF": return log4javascript.Level.OFF;
      default: return log4javascript.Level.INFO; 
    }
  }
  
  trace(...messages: any[]): void {
    this._logger.trace(messages);
  }

  debug(...messages: any[]): void {
    this._logger.debug(messages);
  }

  info(...messages: any[]): void {
    this._logger.info(messages);
  }

  warn(...messages: any[]): void {
    this._logger.warn(messages);
  }

  error(...messages: any[]): void {
    this._logger.error(messages);
  }

  fatal(...messages: any[]): void {
    this._logger.fatal(messages);
  }

  private readonly _logger = log4javascript.getLogger();
}
